import GlobalStyles from "@mui/material/GlobalStyles";

const scrollStyles = {
  "html.portal-scroll-enabled, body.portal-scroll-enabled, #root.portal-scroll-enabled": {
    overflow: "visible !important",
    height: "auto !important",
  },
  "body.portal-scroll-enabled": {
    overflowX: "hidden !important",
    overflowY: "visible !important",
    touchAction: "pan-y pinch-zoom",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  },
  "body.portal-scroll-enabled::-webkit-scrollbar": {
    display: "none",
  },
  "html.portal-scroll-enabled::-webkit-scrollbar": {
    display: "none",
  },
};

export default function PortalScrollGlobalStyles() {
  return <GlobalStyles styles={scrollStyles} />;
}
